var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":_vm.size,"width":_vm.size}},[_c('circle',{class:_vm.colorClass,attrs:{"cx":_vm.halfSize,"cy":_vm.halfSize,"r":_vm.halfSize}},[_c('title',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }